import React from 'react'

import { makeStyles } from '@material-ui/styles'

import useRouter from 'utils/useRouter'
import { Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import theme from 'theme'

const useStyles = makeStyles((theme) => ({
  voltar: {
    marginTop: theme.spacing(2),
    backgroundColor: '#E9E7DA',
    color: '#595959',
    '&:hover': {
      backgroundColor: '#E9E7DB',
      color: '#595959',
    }
  },
  iconVoltar: {
    marginRight: theme.spacing(1),
  },
}))

export const BackButton = (props) => {
  const { top, size } = props
  const classes = useStyles()
  const router = useRouter() //eslint-disable-line

  const getMarginTop = () => {
    if (top) {
      return top === 0 || top === '0' ? 0 : theme.spacing(top)
    }
    return theme.spacing(2)
  }

  return (
    <Button
      aria-controls="customized-menu"
      className={classes.voltar}
      aria-haspopup="true"
      variant="contained"
      size={size || 'medium'}
      onClick={() => router.history.goBack()}
    >
      <ArrowBackIcon className={classes.iconVoltar} />
      Voltar
    </Button>
  )
}
